import CurrencyFormatter from "./currency-formatter";

export default function(){

    const currencyFormatter = CurrencyFormatter();

    const formatEstimate = (quote) => {
        if (!quote) {
            return null;
        }

        let formattedEstimate, formattedType, formattedValue = null;
        const {value, type, date, detail, currency} = quote
        if(value) {
            formattedValue = currencyFormatter.format((value * 100), true, currency);
        }

        if(type) {
            if (type == "onceoff") {
                formattedType = " ";
            } else {
                formattedType = `Per ${type}`;
            }
        }

        formattedEstimate = {
            date: date,
            detail: detail,
            type: formattedType,
            value: formattedValue
        }

        return formattedEstimate
    }

    const formatValue = (value) => {
        if (value < 100) {
            return value.toLocaleString();
        } else {
            return Math.round(value).toLocaleString();
        }
    }

    return {
        formatEstimate
    }
}

